import React, { useEffect, useState } from "react";
import { BadgeCheck } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { menuCheck } from "../api";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" }) : "—");

// "Qora Menu Verificato": shown only when a professional verification is currently valid. Click → details + disclaimer.
export default function VerifiedBadge({ menuId, className = "" }) {
  const [b, setB] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (menuId) menuCheck.badge(menuId).then(({ data }) => setB(data)).catch(() => setB(null)); }, [menuId]);
  if (!b?.valid) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="verified-badge" aria-label="Dettagli Qora Menu Verificato"
        className={`inline-flex items-center gap-2 rounded-full border border-[#8fd7c4] bg-[#dff3ec] pl-1.5 pr-3 py-1 text-left hover:bg-[#c9ebe0] transition-colors ${className}`}>
        <span className="h-6 w-6 rounded-full bg-[#0c2d34] grid place-items-center"><BadgeCheck className="h-4 w-4 text-[#8fd7c4]" /></span>
        <span className="leading-tight"><span className="block text-[12px] font-extrabold text-[#0c2d34]">{b.badge_text}</span><span className="block text-[10px] text-[#2f5d63]">{b.badge_sub}</span></span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="verified-dialog">
          <DialogTitle className="flex items-center gap-2 font-display text-xl text-[#0c2d34]"><BadgeCheck className="h-5 w-5 text-[#2f7f78]" /> {b.badge_text}</DialogTitle>
          <DialogDescription>Verifica professionale privata del documento menù.</DialogDescription>
          <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
            {[["Data verifica", fmt(b.verified_at)], ["Menù / versione", `Versione ${b.document_version}`], ["Professionista", b.professional], ["Qualifica", b.qualification], ["Ambito", b.scope], ["Prossima revisione", fmt(b.next_review)], ["Stato", "Verificato"]].map(([k, v]) => <React.Fragment key={k}><dt className="text-muted-foreground">{k}</dt><dd className="font-semibold text-[#0c2d34]" data-testid={`verified-${k.toLowerCase().replace(/[^a-z]/g, "-")}`}>{v}</dd></React.Fragment>)}
          </dl>
          <p className="mt-3 text-xs text-muted-foreground border-t border-border pt-3">{b.disclaimer}</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
